import * as yup from 'yup';
import {
  ERROR_REQUIRED,
  ERROR_MAX_LENGTH_30,
  ERROR_EMAIL_FORMAT,
} from '@client/definitions/errorMessages';

export const accountInformationValidationSchema = () => {
  return yup.object().shape({
    firstName: yup
      .string()
      .required(ERROR_REQUIRED)
      .max(30, ERROR_MAX_LENGTH_30),
    lastName: yup
      .string()
      .required(ERROR_REQUIRED)
      .max(30, ERROR_MAX_LENGTH_30),
    email: yup
      .string()
      .required(ERROR_REQUIRED)
      .email(ERROR_EMAIL_FORMAT),
  });
};
